import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronDownFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m6,9.25c-.192,0-.384-.073-.53-.22L1.22,4.78c-.293-.293-.293-.768,0-1.061s.768-.293,1.061,0l3.72,3.72,3.72-3.72c.293-.293.768-.293,1.061,0s.293.768,0,1.061l-4.25,4.25c-.146.146-.338.22-.53.22Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconChevronDownFill12.js.map